import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributing"
    }}>{`Contributing`}</h1>
    <h2 {...{
      "id": "setting-up-dev-environment"
    }}>{`Setting up Dev Environment`}</h2>
    <h3 {...{
      "id": "cloning-the-repository"
    }}>{`Cloning the Repository:`}</h3>
    <p>{`Using SSH`}</p>
    <pre><code parentName="pre" {...{}}>{`git clone git@github.com:Codebrahma/react-flexible-sliding-menu.git
`}</code></pre>
    <p>{`or Using HTTPS`}</p>
    <pre><code parentName="pre" {...{}}>{`git clone https://github.com/Codebrahma/react-flexible-sliding-menu.git
`}</code></pre>
    <h3 {...{
      "id": "installing-dependencies"
    }}>{`Installing Dependencies:`}</h3>
    <pre><code parentName="pre" {...{}}>{`cd react-flexible-sliding-menu
npm install
`}</code></pre>
    <h3 {...{
      "id": "create-testing-app"
    }}>{`Create Testing App:`}</h3>
    <p>{`Testing App should be present outside `}<inlineCode parentName="p">{`react-flexible-sliding-menu`}</inlineCode>{`, we suggest create `}<inlineCode parentName="p">{`testing-app`}</inlineCode>{` as a sibling folder.`}</p>
    <pre><code parentName="pre" {...{}}>{`npx create-react-app testing-app

`}</code></pre>
    <p>{`If you followed the steps correctly your folder structure should look like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`react-flexible-sliding-menu/
testing-app/
`}</code></pre>
    <p>{`Now we need to link `}<inlineCode parentName="p">{`react-flexible-sliding-menu`}</inlineCode>{` and the `}<inlineCode parentName="p">{`testing-app`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd testing-app
npm link ../react-flexible-sliding-menu
`}</code></pre>
    <h3 {...{
      "id": "linking-react-and-react-dom-to-testing-app"
    }}>{`Linking `}<inlineCode parentName="h3">{`react`}</inlineCode>{` and `}<inlineCode parentName="h3">{`react-dom`}</inlineCode>{` to `}<inlineCode parentName="h3">{`testing-app`}</inlineCode>{`:`}</h3>
    <pre><code parentName="pre" {...{}}>{`cd react-flexible-sliding-menu
npm link ../testing-app/node_modules/react
npm link ../testing-app/node_modules/react-dom
`}</code></pre>
    <p>{`Now you should be able to simply import `}<inlineCode parentName="p">{`react-flexible-sliding-menu`}</inlineCode>{` in your `}<inlineCode parentName="p">{`testing-app`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "contributing-to-library-code"
    }}>{`Contributing to Library Code:`}</h2>
    <p>{`Run the Library Server:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd react-flexible-sliding-menu/
npm start
`}</code></pre>
    <p>{`Run the Testing App:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd testing-app
npm start
`}</code></pre>
    <p>{`Now you can edit the code of library and see the changes in the `}<inlineCode parentName="p">{`testing-app`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "contributing-to-docs"
    }}>{`Contributing to Docs:`}</h2>
    <p>{`Run the Docs Server:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd react-flexible-sliding-menu/
npm run docz:dev
`}</code></pre>
    <p>{`Now you can edit the `}<inlineCode parentName="p">{`md/mdx`}</inlineCode>{` files present inside the `}<inlineCode parentName="p">{`docs`}</inlineCode>{` folder and see the changes on the server.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      